import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import InlineLoader from '@jetbrains/ring-ui/components/loader-inline/loader-inline';
import Select from '@jetbrains/ring-ui/components/select/select';
import { usePluginVersions } from '@common/queries/plugins';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { useFeatureFlag } from '@common/server-config-context/server-config-context';
import serverConfig from '@common/server-config-context/server-config';
export function VersionSelector(props) {
    const { pluginId, version, onVersionChange, className } = props;
    const { data, isFetching } = usePluginVersions(pluginId);
    const allowDenyPluginsListEnabled = useFeatureFlag('allowDenyPluginsListEnabled');
    const cloudModeEnabled = serverConfig.isCloud();
    const fixedOptions = useMemo(() => [
        allowDenyPluginsListEnabled
            ? { label: 'All', key: 'all', version: { type: 'all' }, ...assignTestId('all-version') }
            : undefined,
        !cloudModeEnabled
            ? {
                label: 'Latest',
                key: 'latest',
                version: { type: 'latest' },
                ...assignTestId('latest-version')
            }
            : undefined
    ].filter(Boolean), [allowDenyPluginsListEnabled, cloudModeEnabled]);
    const options = useMemo(() => {
        if (!data) {
            return fixedOptions;
        }
        return fixedOptions.concat(data.items.map(version => ({
            label: version.version,
            key: version.id,
            version: allowDenyPluginsListEnabled
                ? {
                    type: 'specific',
                    version: { id: version.id, name: version.version }
                }
                : { type: 'specific', version: { id: version.version, name: version.version } }
        })));
    }, [data, fixedOptions, allowDenyPluginsListEnabled]);
    const selectedVersion = options.find(option => {
        if ((version === null || version === void 0 ? void 0 : version.type) === 'specific' && option.version.type === 'specific') {
            return option.version.version.id === version.version.id;
        }
        return option.version.type === (version === null || version === void 0 ? void 0 : version.type);
    });
    const handleSelect = (item) => {
        if (item) {
            onVersionChange(item.version);
        }
    };
    if (isFetching) {
        return _jsx(InlineLoader, {});
    }
    return (_jsx(Select, { ...assignTestId('version-selector'), onSelect: handleSelect, selected: selectedVersion, className: className, data: options }));
}
